// GENERATED FILE - DO NOT MODIFY

export enum ManagementRoleDto {
    Administrator = "Administrator",
}